import { AdType } from './ads.types';
import {
  collection,
  CollectionReference,
  getDocs,
  where,
  query,
} from 'firebase/firestore';
import { db } from '@util/firebase';


const adsRef = collection(db, 'ads') as CollectionReference<AdType>;

// Shuffles so multiple active ads of the same type/slot rotate across page
// loads instead of the query always returning the same doc first.
function shuffle<T>(items: T[]): T[] {
  const result = [...items];
  for (let i = result.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [result[i], result[j]] = [result[j], result[i]];
  }
  return result;
}

export async function getNAds(n: number, type: string): Promise<AdType[]> {
  const q = query(adsRef, where("active", "==", true), where("type", "==", type));
  const snapshot = await getDocs(q);

  const ads = snapshot.docs.map((doc) => ({
    ...doc.data(),
    id: doc.id
  }));

  return shuffle(ads).slice(0, n);
}